var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "[ c-island c-island--large@lg ]  t-background-white-grey t-margin-bottom-s"
    },
    [
      _c("h2", { staticClass: "t-text-style-beta" }, [
        _vm._v("Kurser och intyg")
      ]),
      _vm._v(" "),
      _c(
        "table",
        { staticClass: "c-list-component  t-margin-top-s" },
        [
          _vm._l(_vm.rows, function(row) {
            return [
              _vm.inEditMode.includes(row.id)
                ? [
                    _c("competence-card-course-data-provider", {
                      key: row,
                      attrs: {
                        "competence-card-id": _vm.competenceCardId,
                        "course-id": row.id
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(dataProvider) {
                              return _c("tr", {}, [
                                _c(
                                  "td",
                                  { attrs: { colspan: "8" } },
                                  [
                                    _c(
                                      "competence-card-course",
                                      _vm._b(
                                        {
                                          attrs: {
                                            mode: "edit",
                                            "competence-card-id":
                                              _vm.competenceCardId,
                                            courseOptions:
                                              dataProvider.courseOptions
                                          },
                                          on: {
                                            cancelEditCourse: _vm.goToViewMode,
                                            editCourse: dataProvider.editCourse,
                                            deleteCourse:
                                              dataProvider.deleteCourse
                                          }
                                        },
                                        "competence-card-course",
                                        dataProvider.course,
                                        false
                                      )
                                    )
                                  ],
                                  1
                                )
                              ])
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                : _c(
                    "list-row",
                    { key: row, attrs: { row: row } },
                    [
                      _c("template", { slot: "last-item" }, [
                        _c(
                          "td",
                          { staticClass: "c-list-item list-item-icon" },
                          [
                            _c("span", { staticClass: "c-list-item__label" }, [
                              _vm._v("Visas på kompetenskort")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "t-text-style-epsilon" }, [
                              _c(
                                "span",
                                { staticClass: "c-icon-link checkboxborder" },
                                [
                                  _c(
                                    "span",
                                    {
                                      class:
                                        "c-icon  c-icon--link c-icon-link_icon " +
                                        row.printOptionClass,
                                      attrs: { "aria-hidden": "true" }
                                    },
                                    [
                                      _c("svg", [
                                        _c("use", {
                                          attrs: {
                                            "xlink:href": "#icon-checkbox"
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _c("span")
                                ]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "c-list-item t-text-align-right" },
                          [
                            _vm.$can("manage", "CompetenceCard")
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "c-button c-button--linkstyle c-button--reset",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.goToEditMode(row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("Ändra")]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ],
                    2
                  )
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.$can("manage", "CompetenceCard") && !_vm.showCreate
        ? _c(
            "button",
            {
              staticClass: "c-button c-button--primary t-margin-top-m",
              attrs: { type: "button" },
              on: { click: _vm.toggleCreate }
            },
            [_vm._v("Lägg till kurs eller intyg")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreate
        ? _c("competence-card-course-data-provider", {
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(dataProvider) {
                    return [
                      _c("competence-card-course", {
                        attrs: {
                          mode: "create",
                          "competence-card-id": _vm.competenceCardId,
                          courseOptions: dataProvider.courseOptions
                        },
                        on: {
                          addCourse: dataProvider.addCourse,
                          cancelAddCourse: _vm.toggleCreate
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              42589344
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }